export default __webpack_public_path__ + "static/media/icons-project.cab0e4c3.svg";